export const minimums = {
  amount: 1,
  fiscalValue: 0,
  lotAmount: 1,
};
